import axios from "axios"

export default {
    state: {
        sliders: []
    },
    getters: {
        imageSliders(state) {
            return state.sliders;
        }
    },
    mutations: {
        setImageSlider(state, imageSliders) {
            state.sliders = imageSliders;
        }
    },
    actions: {
        async getImageSlider({ commit }) {
            let res = await axios.get('/image_silders');
            let imageSliders = res.data.data;

            commit('setImageSlider', imageSliders)
        }
    }
}